import { render } from "./CreateWOCategory.vue?vue&type=template&id=70a0a17d"
import script from "./CreateWOCategory.vue?vue&type=script&lang=js"
export * from "./CreateWOCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__